import store from '../store'
import * as toastTypes from '../modules/toast/store/actions-types'
export function swall (msg = null, confirm = false, icon = "exclamation", theme = 'warning', timer = 5, callback = null) {
    store.dispatch(toastTypes.setThemeToast, theme)
    store.dispatch(toastTypes.setMessageToast, msg)
    store.dispatch(toastTypes.setIconToast, icon)
    store.dispatch(toastTypes.setTimerToast, timer)
    store.dispatch(toastTypes.setCallbackToast, callback)
    if(confirm) {
        store.dispatch(toastTypes.setShowToastConfirm,true)
    } else {
        store.dispatch(toastTypes.setShowToast, true)
        if(!callback) {
            setTimeout(() => {
                store.dispatch(toastTypes.setShowToast, false)
            }, (timer * 1000));
        }
    }
}
